var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3231 21.2924C1.8169 21.2924 1.3865 21.1151 1.0319 20.7605C0.6773 20.4057 0.5 19.9753 0.5 19.4693V6.91516C0.5 6.40916 0.6773 5.97886 1.0319 5.62426C1.3865 5.26966 1.8169 5.09236 2.3231 5.09236H5.3V2.11516C5.3 1.60916 5.4773 1.17886 5.8319 0.824258C6.1865 0.469658 6.6169 0.292358 7.1231 0.292358H14.8769C15.3831 0.292358 15.8135 0.469658 16.1681 0.824258C16.5227 1.17886 16.7 1.60916 16.7 2.11516V9.89236H19.6769C20.1831 9.89236 20.6135 10.0697 20.9681 10.4243C21.3227 10.7789 21.5 11.2092 21.5 11.7152V19.4693C21.5 19.9753 21.3227 20.4057 20.9681 20.7605C20.6135 21.1151 20.1831 21.2924 19.6769 21.2924H12.5V16.4924H9.5V21.2924H2.3231ZM2.3 19.4924H5.3V16.4924H2.3V19.4924ZM2.3 14.6924H5.3V11.6924H2.3V14.6924ZM2.3 9.89236H5.3V6.89236H2.3V9.89236ZM7.1 14.6924H10.1V11.6924H7.1V14.6924ZM7.1 9.89236H10.1V6.89236H7.1V9.89236ZM7.1 5.09236H10.1V2.09236H7.1V5.09236ZM11.9 14.6924H14.9V11.6924H11.9V14.6924ZM11.9 9.89236H14.9V6.89236H11.9V9.89236ZM11.9 5.09236H14.9V2.09236H11.9V5.09236ZM16.7 19.4924H19.7V16.4924H16.7V19.4924ZM16.7 14.6924H19.7V11.6924H16.7V14.6924Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionVisitIcon);
export default __webpack_public_path__ + "static/media/institution_visit_icon.18984d18fff4f294f9f90165dd3059b3.svg";
export { ForwardRef as ReactComponent };